import ApiUtils from "../ApiUtils";
import authStore from "../../../core/services/authStore/authStore";

export default class ApiAuthService {

    async LogIn(user) {
        const response = await ApiUtils.callApi("user/login",'post',user);
        if(response && response?.data?.success == true){
          authStore.commit("setUser",response.data);
        }
        return response;
    }

    async LogOut() {
        const response = await ApiUtils.callApi("user/logout",'post');
        if(response && response?.data?.success == true){
          authStore.commit("logout");
        }
    }
    
    async verifyEmail(formData) {
      return await ApiUtils.callApi("user/forgot-password",'post',formData);
    }

    async verifyOtp(formData) {
      return await ApiUtils.callApi("user/forgot-password/otp-verify",'post',formData);
    }

    async resetPassword(formData) {
      return await ApiUtils.callApi("user/forgot-password/reset-password",'post',formData);
    }
}
